import React from 'react';
import { GenericListPage } from '../../components/generic';
import { NotificationRecord } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useNotificationsList } from './useData';

const List: React.FC = () => {
  const useData = (searchParams?: string) => {
    const params = searchParams ? new URLSearchParams(searchParams.startsWith('?') ? searchParams.slice(1) : searchParams) : new URLSearchParams();
    const filters: { type?: string; read?: boolean; limit?: number } = { limit: 200 };
    const type = params.get('type');
    if (type) filters.type = type;
    const readParam = params.get('read');
    if (readParam === 'true') filters.read = true;
    if (readParam === 'false') filters.read = false;
    return useNotificationsList(filters);
  };

  return (
    <GenericListPage<NotificationRecord>
      useData={useData}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
